// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Charts Overview Page Styles */

.charts-overview {
  padding: 2rem;
  background: transparent;
  min-height: 100vh;
  color: #ffffff;
}

.charts-overview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.charts-overview-header h1 {
  font-size: 2rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.btn-create-model {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.btn-create-model:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Section Styles */
.overview-section {
  margin-bottom: 3rem;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 1.5rem;
} 

/* Materials Grid - 3 columns for Recent Views and Your Models */
.materials-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.material-card {
  background: rgba(30, 30, 50, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 240px;
}

.material-card:hover {
  background: rgba(40, 40, 60, 0.7);
  border-color: rgba(139, 92, 246, 0.5);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.2);
}

/* Header - Top Right aligned */
.material-header {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 0.75rem;
}

.material-price {
  font-size: 1.15rem;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.2;
}

.material-date {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.2;
  margin-top: 0.15rem;
}

/* Chart - Center, Full Width */
.material-chart-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0.5rem 0;
  min-height: 120px;
}

.material-chart {
  width: 100%;
  display: block;
}

/* Footer - Bottom Left aligned */
.material-footer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0.75rem;
}

.material-name {
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
  margin-bottom: 0.15rem;
}

.material-subtitle {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.2;
}

/* Sectors Grid - 4 columns for Related Fields and All Sectors (same as material cards when unpinned) */
.sectors-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
}

.sector-card {
  background: rgba(30, 30, 50, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.sector-card:hover {
  background: rgba(40, 40, 60, 0.7);
  border-color: rgba(139, 92, 246, 0.5);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.2);
}

.sector-image {
  width: 100%;
  height: 160px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(59, 130, 246, 0.3) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.sector-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sector-placeholder {
  font-size: 3rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
}

.sector-name-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  background: rgba(51, 51, 51, 0.1);
  backdrop-filter: blur(3.75px);
  -webkit-backdrop-filter: blur(3.75px);
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.15), 2px 0 2px rgba(255, 255, 255, 0.15);
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom: none;
}

.sector-name {
  padding: 1rem;
  font-size: 1.05rem;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  background: rgba(20, 20, 35, 0.5);
}

/* Responsive Design */

/* When sidebar is unpinned (minimized) - more space available */
.content_unpinned .materials-grid {
  grid-template-columns: repeat(4, 1fr);
}

.content_unpinned .sectors-grid {
  grid-template-columns: repeat(4, 1fr);
}

/* When sidebar is pinned (expanded) - standard layout */
.content_pinned .materials-grid {
  grid-template-columns: repeat(3, 1fr);
}

.content_pinned .sectors-grid {
  grid-template-columns: repeat(4, 1fr);
}

/* Tablet view */
@media (max-width: 1200px) {
  .materials-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .sectors-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Mobile view */
@media (max-width: 768px) {
  .charts-overview {
    padding: 1rem;
  }

  .charts-overview-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .materials-grid,
  .sectors-grid {
    grid-template-columns: 1fr;
  }

  .btn-create-model {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/charts-overview.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,uGAAuG;AACvG;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6FAA6F;EAC7F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,qCAAqC;EACrC,qFAAqF;EACrF,gDAAgD;EAChD,iDAAiD;EACjD,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,sBAAsB;;AAEtB,gEAAgE;AAChE;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,wDAAwD;AACxD;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Charts Overview Page Styles */\n\n.charts-overview {\n  padding: 2rem;\n  background: transparent;\n  min-height: 100vh;\n  color: #ffffff;\n}\n\n.charts-overview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.charts-overview-header h1 {\n  font-size: 2rem;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.btn-create-model {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.btn-create-model:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n/* Section Styles */\n.overview-section {\n  margin-bottom: 3rem;\n}\n\n.section-title {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #ffffff;\n  margin-bottom: 1.5rem;\n} \n\n/* Materials Grid - 3 columns for Recent Views and Your Models */\n.materials-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n}\n\n.material-card {\n  background: rgba(30, 30, 50, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 1.25rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  overflow: hidden;\n  backdrop-filter: blur(10px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 240px;\n}\n\n.material-card:hover {\n  background: rgba(40, 40, 60, 0.7);\n  border-color: rgba(139, 92, 246, 0.5);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.2);\n}\n\n/* Header - Top Right aligned */\n.material-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-bottom: 0.75rem;\n}\n\n.material-price {\n  font-size: 1.15rem;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.2;\n}\n\n.material-date {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.5);\n  line-height: 1.2;\n  margin-top: 0.15rem;\n}\n\n/* Chart - Center, Full Width */\n.material-chart-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 0.5rem 0;\n  min-height: 120px;\n}\n\n.material-chart {\n  width: 100%;\n  display: block;\n}\n\n/* Footer - Bottom Left aligned */\n.material-footer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-top: 0.75rem;\n}\n\n.material-name {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.3;\n  margin-bottom: 0.15rem;\n}\n\n.material-subtitle {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.2;\n}\n\n/* Sectors Grid - 4 columns for Related Fields and All Sectors (same as material cards when unpinned) */\n.sectors-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n}\n\n.sector-card {\n  background: rgba(30, 30, 50, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n}\n\n.sector-card:hover {\n  background: rgba(40, 40, 60, 0.7);\n  border-color: rgba(139, 92, 246, 0.5);\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.2);\n}\n\n.sector-image {\n  width: 100%;\n  height: 160px;\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(59, 130, 246, 0.3) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.sector-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.sector-placeholder {\n  font-size: 3rem;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.8);\n  text-transform: uppercase;\n}\n\n.sector-name-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 25%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  text-align: center;\n  background: rgba(51, 51, 51, 0.1);\n  backdrop-filter: blur(3.75px);\n  -webkit-backdrop-filter: blur(3.75px);\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.15), 2px 0 2px rgba(255, 255, 255, 0.15);\n  border-left: 1px solid rgba(255, 255, 255, 0.05);\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  border-bottom: none;\n}\n\n.sector-name {\n  padding: 1rem;\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: #ffffff;\n  text-align: center;\n  background: rgba(20, 20, 35, 0.5);\n}\n\n/* Responsive Design */\n\n/* When sidebar is unpinned (minimized) - more space available */\n.content_unpinned .materials-grid {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n.content_unpinned .sectors-grid {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* When sidebar is pinned (expanded) - standard layout */\n.content_pinned .materials-grid {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.content_pinned .sectors-grid {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* Tablet view */\n@media (max-width: 1200px) {\n  .materials-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .sectors-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n/* Mobile view */\n@media (max-width: 768px) {\n  .charts-overview {\n    padding: 1rem;\n  }\n\n  .charts-overview-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .materials-grid,\n  .sectors-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .btn-create-model {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
